/* Legacy HTML-card config: window.__PANO__ = {xml: 'https://…/tour.xml'}. */
(function () {
    function initPanorama() {
        const container = document.querySelector('[data-panorama]');
        if (!container || container.dataset.initialized) return;
        container.dataset.initialized = 'true';

        const status = container.querySelector('[data-panorama-status]');
        const config = window.__PANO__;

        function showMessage(key) {
            status.textContent = container.dataset[key];
            status.hidden = false;
        }

        function showError(error) {
            showMessage('errorMessage');
            console.error('[Sigoo panorama]', error);
        }

        if (!config || typeof config.xml !== 'string' || !config.xml.trim()) {
            showMessage('missingMessage');
            return;
        }

        if (typeof window.embedpano !== 'function') {
            showError('The krpano script did not load.');
            return;
        }

        showMessage('loadingMessage');

        try {
            window.embedpano({
                target: 'krp_div',
                xml: config.xml.trim(),
                html5: 'only',
                mobilescale: 1.0,
                // Preserve tour deep links without accepting arbitrary XML/action overrides.
                passQueryParameters: 'startscene,startlookat',
                onready: function (viewer) {
                    // A named event preserves handlers from existing tours and skins.
                    viewer.set('events[sigoo_panorama].keep', true);
                    viewer.set('events[sigoo_panorama].onxmlerror', function () {
                        showError(viewer.get('lasterror'));
                    });
                    viewer.set('events[sigoo_panorama].onxmlcomplete', function () {
                        status.hidden = true;
                    });
                    status.hidden = true;
                },
                onerror: showError
            });
        } catch (error) {
            showError(error);
        }
    }

    // Wait for inline HTML cards and Header/Footer code injection, and for deferred krpano.js.
    if (document.readyState === 'complete') {
        initPanorama();
    } else {
        document.addEventListener('DOMContentLoaded', initPanorama, {once: true});
    }
})();
